const Fornecedor = {
    id: 0,
    nome: ""
}

export default Fornecedor;